export default __webpack_public_path__ + "static/media/ratheg3.4598fbfe.png";